import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const cdProductCardDefaultVariants = {}
const cdProductCardCompoundVariants = []

const cdProductCardSlotNames = [
  [
    "root",
    "cd-product-card__root"
  ],
  [
    "grid",
    "cd-product-card__grid"
  ],
  [
    "imageArea",
    "cd-product-card__imageArea"
  ],
  [
    "starRatingArea",
    "cd-product-card__starRatingArea"
  ],
  [
    "starRatingInner",
    "cd-product-card__starRatingInner"
  ],
  [
    "starRatingTooltip",
    "cd-product-card__starRatingTooltip"
  ],
  [
    "starRatingTrigger",
    "cd-product-card__starRatingTrigger"
  ],
  [
    "titleArea",
    "cd-product-card__titleArea"
  ],
  [
    "titleText",
    "cd-product-card__titleText"
  ],
  [
    "driversArea",
    "cd-product-card__driversArea"
  ],
  [
    "ctaArea",
    "cd-product-card__ctaArea"
  ],
  [
    "ctaInner",
    "cd-product-card__ctaInner"
  ],
  [
    "footer",
    "cd-product-card__footer"
  ]
]
const cdProductCardSlotFns = /* @__PURE__ */ cdProductCardSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, cdProductCardDefaultVariants, getSlotCompoundVariant(cdProductCardCompoundVariants, slotName))])

const cdProductCardFn = memo((props = {}) => {
  return Object.fromEntries(cdProductCardSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const cdProductCardVariantKeys = []
const getVariantProps = (variants) => ({ ...cdProductCardDefaultVariants, ...compact(variants) })

export const cdProductCard = /* @__PURE__ */ Object.assign(cdProductCardFn, {
  __recipe__: false,
  __name__: 'cdProductCard',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: cdProductCardVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, cdProductCardVariantKeys)
  },
  getVariantProps
})